import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Dropdown from "@mui/joy/Dropdown";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import { Avatar } from "@mui/joy";
import {
  useOnlineUsersToggleQuery,
  useUserByIdQuery,
} from "../__generated__/types-and-hooks";
import AvatarGroup from "@mui/joy/AvatarGroup";
import UserAvatar from "./UserAvatar";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n";

export function UserMenuItem({ userId }: { userId: number }) {
   const t = useTranslation();
  const navigate = useNavigate();
  const userByIdQuery = useUserByIdQuery({ variables: { id: userId } });
  const user = userByIdQuery.data?.user_by_id; 
  const handleClick = useCallback(() => {
    if (user) {
      navigate("/user/" + user.slug);
    }
  }, [navigate, user]);

  const label = [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||t('User');

  return (
    <MenuItem onClick={handleClick}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <UserAvatar online userId={userId} size="sm" />
        <Box sx={{ ml: 1.5 }}>
          <Typography level="title-sm" textColor="text.primary">
            {label}
          </Typography>
        </Box>
      </Box>
    </MenuItem>
  );
}

const MAX_ELEMENTS_IN_MENU = 3;

export default function OnlineUsersToggle() {
  const userListQuery = useOnlineUsersToggleQuery();
  const onlineUsers = userListQuery.data?.user_list?.map((u) => u.id) ?? [];

  return (
    <Dropdown>
      <MenuButton variant="plain" size="sm">
        <AvatarGroup>
          {onlineUsers.slice(0, MAX_ELEMENTS_IN_MENU).map((userId) => (
            <UserAvatar key={userId} userId={userId} size="sm" online />
          ))}
          {onlineUsers.length > MAX_ELEMENTS_IN_MENU && (
            <Avatar variant="solid" size="sm">
              +{onlineUsers.length - MAX_ELEMENTS_IN_MENU}
            </Avatar>
          )}
        </AvatarGroup>
      </MenuButton>
      <Menu
        placement="bottom-end"
        size="sm"
        sx={{
          zIndex: "99999",
          p: 1,
          gap: 1,
          "--ListItem-radius": "var(--joy-radius-sm)",
        }}
      >
        {onlineUsers.map((userId) => (
          <UserMenuItem key={userId} userId={userId} />
        ))}
      </Menu>
    </Dropdown>
  );
}
